var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGhostie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "72px",
    viewBox: "0 0 54 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E9F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3CFEE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tiered",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d-Tiered---Error",
    transform: "translate(-613.000000, -302.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(613.000000, 302.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5920809,71.3408149 L25.3183398,64.8931603 C26.2141449,63.8848817 27.7876747,63.8848817 28.6821066,64.8931603 L34.4083654,71.3408149 C35.287279,72.2197284 36.7118055,72.2197284 37.590719,71.3408149 L43.6306402,64.5415948 C44.4054574,63.6696852 45.7190211,63.5333163 46.6554759,64.2308165 L50.1600063,66.8366578 C51.5773916,68.2541805 54.0004463,67.2500218 54.0004463,65.246099 L54.0004463,27.0000401 C54.0004463,11.8124145 41.4608224,-0.445957057 26.1704739,0.0124512731 C11.3920924,0.455478616 0,13.3480412 0,28.1320532 L0,65.246099 C0,67.2515324 2.4230547,68.2541805 3.84044007,66.8366578 L7.34497038,64.2308165 C8.28142526,63.5346896 9.59498897,63.6696852 10.3698062,64.5415948 L16.4097273,71.3408149 C17.2886408,72.2197284 18.7131674,72.2197284 19.5920809,71.3408149 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0001488,31.5000772 C15.5152955,31.5000772 13.5001116,29.4848934 13.5001116,27.0000401 C13.5001116,24.5151868 15.5152955,22.5000029 18.0001488,22.5000029 C20.4850021,22.5000029 22.500186,24.5151868 22.500186,27.0000401 C22.500186,29.4848934 20.4850021,31.5000772 18.0001488,31.5000772 Z",
    id: "Path",
    fill: "#3E4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0002975,31.5000772 C33.5154442,31.5000772 31.5002604,29.4848934 31.5002604,27.0000401 C31.5002604,24.5151868 33.5154442,22.5000029 36.0002975,22.5000029 C38.4851509,22.5000029 40.5003347,24.5151868 40.5003347,27.0000401 C40.5003347,29.4848934 38.4851509,31.5000772 36.0002975,31.5000772 Z",
    id: "Path",
    fill: "#3E4148"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostie);
export default __webpack_public_path__ + "static/media/ghostie.844a4d47abab53c86b4a9e187f3c4a00.svg";
export { ForwardRef as ReactComponent };